import ChattyJSService from '@assets/services/ChattyJSService';
import {useEffect, useState} from 'react';

/**
 * Hook to handle hash URL changes and widget interactions
 * @param {Object} params Hook parameters
 * @param {boolean} params.isPreview Whether widget is in preview mode
 * @param {Function} [params.onHashChange] Optional callback when hash changes
 * @returns {{hashUrl: string, setHashUrl: Function}} Hash URL state and setter
 */

export default function useHashAction({isPreview, onHashChange}) {
  const [hashUrl, setHashUrl] = useState(window.location.hash);

  useEffect(() => {
    !isPreview && additionalChattySdk();
    const handleHashUrlChange = () => {
      setHashUrl(window.location.hash);
      onHashChange && onHashChange();
    };
    window.addEventListener('hashchange', handleHashUrlChange);
    return () => window.removeEventListener('hashchange', handleHashUrlChange);
  }, []);

  useEffect(() => {
    if (isPreview || !hashUrl) return;
    window.ChattyJS.openWidget(hashUrl);

    const floatButtonElm = document.getElementById('Avada-FAQ_WidgetTrigger');
    const customEvent = new CustomEvent('customEvent');
    floatButtonElm.dispatchEvent(customEvent);
  }, [hashUrl, isPreview]);

  return {hashUrl, setHashUrl};
}

function additionalChattySdk() {
  if (!window.ChattyJS) {
    window.ChattyJS = new ChattyJSService();
  }
}
